export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./change-date.vue?vue&type=template&id=48696f84&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/change-date.vue?vue&type=template&id=48696f84&
// module id = 1395
// module chunks = 0